"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportLatestBackupInteractor = void 0;
const rxjs_1 = require("rxjs");
const core_1 = require("@veeam/core");
const helpers_1 = require("../../../helpers");
require("./types");
class ExportLatestBackupInteractor extends core_1.Interactor {
    constructor(listeners, texts) {
        super();
        this.listeners = listeners;
        this.texts = texts;
        this.subscriber = new rxjs_1.Subscription();
        this.onDone = () => __awaiter(this, void 0, void 0, function* () {
            const isValid = this.form.validateAndDisplayErrors();
            if (!isValid) {
                return;
            }
            const { password, hint } = this.form.getValue();
            try {
                yield this.listeners.onDone(password, hint);
                this.listeners.onDeactivate();
            }
            catch (e) { }
        });
        this.onClose = () => {
            var _a, _b;
            this.listeners.onDeactivate();
            (_b = (_a = this.listeners).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.onCancel = () => {
            var _a, _b;
            this.listeners.onDeactivate();
            (_b = (_a = this.listeners).onCancel) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.listeners = listeners;
        this.texts = texts;
        const model = new core_1.Model({
            password: '',
            repeatPassword: '',
            hint: '',
        });
        this.form = new core_1.Form(model, {
            validationSchema: {
                password: [core_1.required()],
                repeatPassword: [core_1.required(), helpers_1.passwordsEqual(this.texts.passwordNotEqual)],
            },
        });
    }
    willActivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriber.add(this.form.model.subscribe((value) => {
                if (value.repeatPassword) {
                    this.form.validateAndDisplayErrors();
                }
            }));
        });
    }
    willDeactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriber.unsubscribe();
        });
    }
}
exports.ExportLatestBackupInteractor = ExportLatestBackupInteractor;
//# sourceMappingURL=ExportLatestBackupInteractor.js.map